import { backendAPI } from "../../helper/apis"

export const FETCH_SERVICE = 'FETCH_SERVICE';

export function fetchPricesByService(serviceId) {
  return backendAPI.get(`/dynamic_price/${serviceId}`);
}